import React, { Component } from "react";
import injectSheet from "react-jss";
// import Color from 'color'
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { flexUtils, palette } from "../../../Theme/Theme";
import ScrollableAnchor from "react-scrollable-anchor";
import { configureAnchors } from "react-scrollable-anchor";
import styled from "styled-components";
import play from "../../../../assets/play.png";
import _ from "lodash";
import * as Actions from "../../../Actions/Actions";
import {HotKeys} from 'react-hotkeys';
import { isMobile } from "react-device-detect";

const Container = styled(HotKeys)`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: row;
  width: 100%;
  min-width: 20rem;
  min-height: 5vw;
  ${'' /* margin-bottom: 2rem;   */}
  position: relative;    
  &:focus {
    border: 0;
  }  
`;

const Title = styled.div.attrs({
  children: "Create New Playlist"
})`
  transition: all 0.4s;
  color: ${palette.white};
  font-size: ${props => props.isMobile ? '1rem' : '2vw' };
  padding-top: 2rem;
  padding-bottom: 2rem;
  padding: 0.5rem;  
  &:hover {
    cursor: pointer;
    color: ${palette.blue};
  }
`;

const Input = styled.input.attrs({
  placeholder: props => props.placeHolder
})`
  color: ${palette.white};
  background-color: black;
  border: 0;
  font-size: ${props => props.isMobile ? '1rem' : '1.5vw' };
  margin: 1rem;
  border-bottom: 1px solid ${palette.white};
  outline: none;
  &:focus {
    outline: none;
  }
`;

const Confirm = styled.div.attrs({
  className: "fas fa-check"
})`
  margin: 1rem;
  transition: all 0.7s;
  font-size: ${props => props.isMobile ? '1rem' : '2vw' };
  color: ${palette.white};
  &:hover {
    color: ${props =>
      props.title !== "" ? `${palette.teal}` : `${palette.white}`};
    cursor: ${props => (props.title !== "" ? "pointer" : "auto")};
  }
`;
const Cancel = Confirm.extend.attrs({
  className: "fas fa-times"
})`
  extends: ${Confirm};
  &:hover {
    color: ${palette.pink};
  }
`;

const ErrorMessage = styled.div.attrs({
  children: props => props.message
})`
  color: ${palette.red};
  font-size: 1.5rem;
  position: absolute;
  width: 20vw;
  text-align: center;
  bottom: -5vh;
  background-color: red;
  z-index: 100;
`;

class AddNewPlaylist extends Component {
  state = {
    showTitle: true,
    playlistTitle: "",
    message: "Playlist name"
  };
  render() {
    const map = {
      create: 'enter'
    };

    const handlers = {
      create: this.createPlaylist
    }
    return (      
      <Container keyMap={map} handlers={handlers}>
        {/* <HotKeys keyMap={map} handlers={handlers}> */}
          {this.state.showTitle ? (
            <Title
              isMobile={isMobile}
              onClick={() => {
                this.setState({ showTitle: false });
              }}
            />
          ) : (
            <React.Fragment>
              <Input
                isMobile={isMobile}
                placeHolder={this.state.message}
                value={this.state.playlistTitle}
                onInput={e => {
                  this.setState({ playlistTitle: e.target.value });
                }}
              />

              <Confirm
                isMobile={isMobile}
                playlists={this.props.playlists}
                title={this.state.playlistTitle}
                onClick={this.createPlaylist}                
              />
              <Cancel
                isMobile={isMobile}
                onClick={() => {
                  this.setState({ playlistTitle: "", showTitle: true });
                }}
              />
              {/* <ErrorMessage message={this.state.message} /> */}
            </React.Fragment>
          )}
        {/* </HotKeys> */}
      </Container>      
    );
  }

  createPlaylist = () => {
    if (this.state.playlistTitle.trim() !== "") { 
      this.setState({ message: "" });
      let title = this.state.playlistTitle.trim();
      for (let i = 0; i < this.props.playlists.length; i++) {
        if (this.props.playlists[i].title === title) {
          this.setState({ message: "Playlist already exists.", playlistTitle: ''});
          return
        }
      }
      this.props.dispatch(Actions.addPlaylist(this.props.user.token, title));
    } else {
      this.setState({message: 'Enter valid name'})
    }
  };
}

const mapStateToProps = state => {
  return {
    user: state.mainState.user,
    playlists: state.mainState.playlists
  };
};

export default withRouter(connect(mapStateToProps)(AddNewPlaylist));



// WEBPACK FOOTER //
// ./src/js/Components/Home/Playlists/AddNewPlaylist.jsx